import React, { useMemo, useCallback, useState, useEffect } from 'react'

import QRCode from 'qrcode'
import { v4 as uuid } from 'uuid';
import { useRouter } from 'next/router'
import Link from 'next/link'
import axios from 'axios'
import { Modal, message, Form, Input, Button } from 'antd'
import Image from 'next/image'

import PageHeader from '@/components/PageHeader'
import { phpHttp } from '@/utils/request'

import wxlogo from './assets/wechat.png'
import qqlogo from './assets/qq.png'

import styles from './SignUp.module.scss'

export default React.memo(function SignUp() {
  const router = useRouter()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [captchaUrl, setCaptchaUrl] = useState('/captcha/new.html?font_size=18')
  const [wechatLoginId, setWechatLoginId] = useState()

  useEffect(() => {
    if (!wechatLoginId) {
      return
    }

    let checkTimes = 0
    const timer = setInterval(async () => {
      const res = await axios.get(`/portal/Login/checkLogin?rk=${wechatLoginId}`)

      if (res.data?.status === 0) {
        clearInterval(timer)
        await userActions.getUserInfo()
        router.replace('/user')
        return
      }

      checkTimes += 1

      if (checkTimes > 30) {
        clearInterval(timer)
        Modal.destroyAll()
      }
    }, 2000)

    return () => {
      clearInterval(timer)
    }
  }, [wechatLoginId])

  const showWechatQR = useCallback(() => {
    Modal.info({
      icon: null,
      title: '请使用微信扫码登录',
      content: <canvas id="qrcode_weixin"/>,
      footer: null,
      destroyOnClose: true,
      maskClosable: true,
      className: styles.modal,
      afterClose: () => setWechatLoginId()
    })

    setTimeout(() => {
      const rk = uuid()
      const url = `${location.origin}/portal/Login/weixinlogin?rk=${rk}`
      QRCode.toCanvas(document.getElementById('qrcode_weixin'), url, { width: 200, errorCorrectionLevel: 'Q' })
      setWechatLoginId(rk)
    }, 300)
  }, [])

  const refreshCaptcha = useCallback(() => {
    setCaptchaUrl(`/captcha/new.html?font_size=18&t=${Math.random()}`)
  }, [])

  const sendCode = useCallback(async () => {
    const values = await form.validateFields(['email'])

    await phpHttp.post('/portal/login/regemail', values)

    message.info('发送成功，请前往邮箱查看')
  }, [])

  const submit = useCallback(async (values) => {
    setLoading(true)

    try {
      await phpHttp.post('/portal/login/regpost', values)

      router.replace('/user')
    } catch(err) {
      console.log(err);
    }
  }, [])

  const qqLogin = useCallback(() => {
    window.open("/plugins/qq/qqlogin.php","TencentLogin","width=450,height=320,menubar=0,scrollbars=1, resizable=1,status=1,titlebar=0,toolbar=0,location=1");
  }, [])

  return (
    <>
      <PageHeader title="创建帐号" />
      <div className={styles.container}>

        <div className={styles.center}>
          <div className={styles.title}>创建帐号</div>

          <Form form={form} className={styles.form} onFinish={submit}>
            <Form.Item name="email" rules={[{ required: true, message: '请输入email' }, { type: 'email', message: 'email格式不正确'}]}>
              <Input placeholder="邮箱地址" maxLength={40}/>
            </Form.Item>
            <Form.Item name="pwd" rules={[{ required: true, message: '请输入密码'}, { min: 6, message: '请最少输入6位密码'}]}>
              <Input placeholder="密码" type="password" maxLength={32}/>
            </Form.Item>
            <Form.Item name="pwd1"
              dependencies={['pwd']}
              rules={[{
                required: true, message: '请输入密码'
              }, {
                min: 6, message: '请最少输入6位密码'
              },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('pwd') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('确认密码于密码不一致'));
                  },
                }),
              ]}
            >
              <Input placeholder="确认密码" type="password" maxLength={32}/>
            </Form.Item>
            <div className={styles.captcha}>
              <Form.Item name="captcha" rules={[{ required: true, message: '请输入验证码'}, { len: 4, message: '请输入4位验证码' }]}>
                <Input placeholder="验证码" maxLength={4}/>
              </Form.Item>
              <img onClick={refreshCaptcha} alt="" src={captchaUrl}/>
            </div>

            <Form.Item>
              <Button block type="primary" onClick={sendCode}>发送邮箱验证码</Button>
            </Form.Item>

            <Form.Item name="code" rules={[{ required: true, message: '请输入邮箱验证码'}]}>
              <Input placeholder="邮箱验证码" maxLength={20}/>
            </Form.Item>

            <Button htmlType="submit" block type="primary">注册</Button>
          </Form>

          <div className={styles.split}>快捷登录</div>

          <div className={styles.otherLogin}>
              <Image
                alt="微信登录"
                src={wxlogo}
                height={44}
                onClick={showWechatQR}
              />
              <Image
                alt="QQ登录"
                src={qqlogo}
                height={44}
                onClick={qqLogin}
              />
          </div>

          <div className={styles.help}>
            <span>
              已有账号? <Link href="./login">立即登录</Link>
            </span>
          </div>
        </div>
      </div>
    </>
  )
})
